import React from 'react'
import {Route} from 'react-router-dom';
import PropTypes from 'prop-types';


export default function RouterWithLayout({layout : Layout, component: Component, ...rest}) {
    return (
        <div style={{height: '100%', 
        // background: 'yellow'
        }}>
            <Route
                {...rest}
                render= { matchProps =>(
                    Layout == null? <Component {...matchProps}/> :
                    <Layout>
                        <Component {...matchProps}/>
                    </Layout>
                )
                }            
            />
        </div>
    )
}

RouterWithLayout.propType = {
    Component: PropTypes.any.isRequired,
    layout: PropTypes.any.isRequired,
    path: PropTypes.string
}